import React from "react";
import style from "./Contact.module.css";

function Contact() {
    return (
        <>
            <div className={style["home"]}>
                HELLO
            </div>
        </>
    );
}

export default Contact;